/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer__AuctionsInputs */

const en_footer__auctions = /** @type {(inputs: Footer__AuctionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auctions`)
};

/**
* | output |
* | --- |
* | "Auctions" |
*
* @param {Footer__AuctionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer__auctions = /** @type {((inputs?: Footer__AuctionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer__AuctionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer__auctions(inputs)
});